export function trimFileName(fileName: string, maxLen: number) {
  const l = fileName.length;
  if (l < maxLen) {
    return fileName;
  }

  const prefixSize = (maxLen - 3) / 2;
  if (prefixSize < 0) {
    return fileName;
  }

  return `${fileName.substring(0, prefixSize)}...${fileName.substring(
    l - prefixSize
  )}`;
}

export function trimTextName(textName: string, ellipsisLen: number) {
  if (textName.length <= ellipsisLen) {
    return textName;
  }

  return `${textName.substring(0, ellipsisLen)}...`;
}

/**
 * Strips filesystem-illegal characters so the value is safe to pass as
 * `<a download="…">` or `pdf.save(…)`. Keeps spaces and commas — the
 * resulting filename is meant to read like a document title.
 */
export const sanitizeFilename = (
  name: string | null | undefined,
  fallback: string,
): string =>
  (name ?? '').replace(/[/\\:*?"<>|]/g, '').trim() || fallback;
